jQuery(function ($) {
    $(document).on('click', '[data-press-load-more]', function (e) {
        e.preventDefault();

        const $btn = $(this);
        const $root = $btn.closest('.press-element--simple');

        $root.find('.hidden-desktop, .hidden-tablet, .hidden-mobile')
            .removeClass('hidden-desktop hidden-tablet hidden-mobile');

        // Hide button after first click
        $btn.prop('hidden', true).addClass('is-hidden');
    });
});
